import { Fragment } from "react"
import Sidebar from "./common/Sidebar";
import Header from "./common/Header";
import Footer from "./common/Footer";
export default function Base(props) {

    const {children, sticky_footer = true, header_title = '', hideDatepicker=true, headerType='', showSearchIcon} = props;
    return (
        <Fragment>
        
        <div id="layout-wrapper">
            <Header  title={header_title} hideDatepicker={hideDatepicker} headerType={headerType} showSearchIcon={showSearchIcon}/>
            <Sidebar/>
            <div className="main-content">
                <div className="page-content">
                    <div className="container-fluid">
                        {children}
                    </div>
                </div>
                <Footer sticky={sticky_footer}/>
            </div>
        </div>
        </Fragment>
        
    )
}